module.exports = __webpack_public_path__ + "static/media/IMG-15.d69c5c3e.jpg";